// This file exists to help with the marketing app bundle size - lodash is big

/**
 * Given an array, split it into 2 sets. One that passes a filter and one that does not.
 * @template T
 * @param array {Array<T>} An array of values of any type.
 * @param isValid {(item: T) => boolean} A filter function
 * @returns {Array<T>,Array<T>} An array of values that pass the test and an array that fail
 */
export function partition(array, isValid) {
  return array.reduce(([pass, fail], elem) => {
    return isValid(elem) ? [[...pass, elem], fail] : [pass, [...fail, elem]];
  }, [[], []]);
}

export const isIOSSafari = () => {
  const ua = window.navigator.userAgent;
  const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
  const webkit = !!ua.match(/WebKit/i);

  return iOS && webkit && !ua.match(/CriOS/i);
};
